import { Form } from '@unform/web';
import styled from 'styled-components';

export const WrapperForm = styled(Form)`
  display: flex;
  flex-direction: column;

  gap: 2rem;

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }
`;

export const WrapperAutocomplete = styled.div`
  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }
`;
